<template>
    <form method="post" action="" v-on:submit="submitForm">
        <div class="form-group">
            <label>User ID: *</label><br />
            <input type="text" name="user_id" v-model="finalData.userId" />
        </div>
        <div class="form-group">
            <button type="submit">{{ submitText || 'Submit' }}</button>
        </div>
    </form>
</template>

<script>
export default {
    name: 'LeakRuleForm',
    props: ['formData', 'submitText'],
    emits: ['formSubmitted'],
    data: function() {
        return {
            finalData: this.formData ? JSON.parse(JSON.stringify(this.formData)) : {},
        }
    },
    methods: {
        submitForm(e) {
            e.preventDefault()
            this.$emit('formSubmitted', this.finalData)
        }
    }
}
</script>

<style lang="scss" scoped>
</style>
